module.exports = __webpack_public_path__ + "./docs/img/search-filter-selected.8fe4f1ac105eb65d2b1a45ab6ad6f0e9.svg";